<template>
  <div class="md:flex">
    <div v-if="showSidebar" class="flex flex-col shrink-0 gap-1 md:w-72 md:border-r md:pr-5">
      <slot name="prepend-sidebar"/>

      <l-button
        v-for="item in items"
        :key="item.title"
        class="inline-flex justify-between items-center gap-3 items-center text-left md:px-3 py-2 rounded"
        :class="[activeItem && activeItem.title === item.title ? 'text-blue dark:text-white bg-gray-100 dark:bg-gray-800' : 'text-gray-600 hover:text-blue dark:hover:text-blue-200 dark:text-white']"
        @click="selectedItem = item"
      >
        <icon
          :name="item.icon"
          :color="activeItem && activeItem.title === item.title ? 'orange' : 'gray'"
          size="3xl"
        />

        <span class="block leading-none flex-1 md:w-48">
          <span class="block font-medium">
            {{ item.title }}
          </span>
          <span class="block mt-1 font-medium text-xs text-gray-500 truncate" aria-hidden="true">
            {{ item.subtitle || 'Not set' }}
          </span>
        </span>
        <icon name="next" class="text-gray-400 text-sm justify-self-end md:hidden"/>
      </l-button>

      <slot name="append-sidebar"/>
    </div>

    <div class="flex-1 flex flex-col gap-4 md:px-5">
      <div v-if="showBackButton">
        <l-button
          class="text-gray-500 text-sm inline-flex gap-1 items-center hover:text-gray-700"
          @click="selectedItem = null"
        >
          <icon
            name="previous"
            class="text-xs"
          />
          Back
        </l-button>
      </div>

      <slot v-if="activeItem" :item="activeItem"/>
    </div>
  </div>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import { breakpoints } from "@/breakpoints"
import { computed, shallowRef } from "vue"

const props = defineProps({
  items: { type: Object, required: true },
})

const selectedItem = shallowRef(null)

const activeItem = computed(() => selectedItem.value ?? defaultItem.value)

const defaultItem = computed(() => (breakpoints.smAndUp ? props.items[0] : null))

const showBackButton = computed(() => activeItem.value && !breakpoints.smAndUp)

const showSidebar = computed(() => !activeItem.value || breakpoints.smAndUp)
</script>
